import { arrayMove } from "@dnd-kit/sortable";
import type { ChapterView } from "@/types/story";

export function applyChapterEdgeRoles(chapters: ChapterView[]) {
  const lastIndex = chapters.length - 1;

  return chapters.map((chapter, index) => ({
    ...chapter,
    isClosing: index === lastIndex && lastIndex >= 0,
    isOpening: index === 0,
  }));
}

export function moveChapterIds(
  orderedChapterIds: string[],
  chapterId: string,
  direction: -1 | 1,
) {
  const currentIndex = orderedChapterIds.indexOf(chapterId);
  const nextIndex = currentIndex + direction;

  if (
    currentIndex < 0 ||
    nextIndex < 0 ||
    nextIndex >= orderedChapterIds.length
  ) {
    return orderedChapterIds;
  }

  return arrayMove(orderedChapterIds, currentIndex, nextIndex);
}

export function reorderChapterIds(
  orderedChapterIds: string[],
  activeChapterId: string,
  overChapterId: string,
) {
  const currentIndex = orderedChapterIds.indexOf(activeChapterId);
  const nextIndex = orderedChapterIds.indexOf(overChapterId);

  if (currentIndex < 0 || nextIndex < 0 || currentIndex === nextIndex) {
    return orderedChapterIds;
  }

  return arrayMove(orderedChapterIds, currentIndex, nextIndex);
}

export function applyExclusiveChapterRole(
  chapters: ChapterView[],
  chapterId: string,
  role: "closing" | "opening",
) {
  return chapters.map((chapter) => {
    if (role === "opening") {
      return {
        ...chapter,
        isOpening: chapter.id === chapterId,
      };
    }

    return {
      ...chapter,
      isClosing: chapter.id === chapterId,
    };
  });
}

export function getFocusNavigationChapterIds(
  chapters: Array<Pick<ChapterView, "id">>,
  activeChapterId: string | null,
) {
  if (!activeChapterId) {
    return {
      nextChapterId: null,
      previousChapterId: null,
    };
  }

  const activeChapterIndex = chapters.findIndex(
    (chapter) => chapter.id === activeChapterId,
  );

  if (activeChapterIndex < 0) {
    return {
      nextChapterId: null,
      previousChapterId: null,
    };
  }

  return {
    nextChapterId: chapters[activeChapterIndex + 1]?.id ?? null,
    previousChapterId: chapters[activeChapterIndex - 1]?.id ?? null,
  };
}
